<template>
  <div class="flex" :class="titleLayout === 'horizontal' ? 'flex-wrap items-center gap-2' : 'flex-col gap-1'">
    <div class="flex items-center gap-1">
      <svg-icon name="ai-indicator" :class="titleLayout === 'horizontal' ? 'size-5' : 'size-4.5'" />
      <span
        class="font-700 bg-clip-text text-transparent bg-[linear-gradient(173.11deg,#f48220_-1.59%,#f32735_71.8%)]"
        :class="titleLayout === 'horizontal' ? 'text-xl' : 'text-base'"
      >
        {{ $t('ai.summary.title') }}
      </span>
    </div>

    <div class="flex items-center gap-1">
      <span class="font-500" :class="{ 'text-lg md:text-xl': titleLayout === 'horizontal' }">{{ subtitle }}</span>
      <n-tooltip
        :placement="appStore.isMobileScreen ? 'bottom' : 'bottom-start'"
        :show-arrow="false"
        :trigger="appStore.isMobileScreen ? 'click' : 'hover'"
        :width="appStore.isMobileScreen ? 260 : 348"
        :content-style="tooltipContentStyle"
      >
        <template #trigger>
          <etg-button type="icon" size="mini" icon="alert" icon-color="gray-80" />
        </template>
        <p class="text-sm text-black-50">{{ tooltipText }}</p>
      </n-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NTooltip } from 'naive-ui'
import { useAppStore } from '@/store/app'

interface Props {
  subtitle: string
  tooltipText: string
  titleLayout?: 'horizontal' | 'vertical'
}

withDefaults(defineProps<Props>(), {
  titleLayout: 'horizontal',
})
const appStore = useAppStore()

const tooltipContentStyle = {
  padding: '20px 16px',
  borderRadius: '4px',
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)',
  backgroundColor: '#fff',
}
</script>
